import { miniApp } from '@tma.js/sdk';

/**
 * Красит собственную обвязку Telegram — шапку, фон и нижнюю панель —
 * в цвет текущей темы приложения.
 *
 * Шаг, который обычно пропускают, и именно поэтому Mini App выглядит
 * как светлый прямоугольник, вклеенный в тёмную шапку.
 */
export function syncTelegramChrome(bgColor: string): void {
  const rgb = toHex(bgColor);
  if (!rgb) return;

  try {
    miniApp.setHeaderColor(rgb);
  } catch {
    /* старый клиент */
  }

  try {
    miniApp.setBgColor(rgb);
  } catch {
    /* старый клиент */
  }

  try {
    miniApp.setBottomBarColor(rgb);
  } catch {
    /* Bot API 7.10+ — на старых клиентах отсутствует */
  }
}

/**
 * Telegram принимает только #rrggbb. Значения из CSS-переменных
 * приходят как есть, поэтому короткую запись нужно развернуть.
 */
function toHex(value: string): `#${string}` | null {
  const v = value.trim();
  if (/^#[0-9a-f]{6}$/i.test(v)) return v as `#${string}`;
  if (/^#[0-9a-f]{3}$/i.test(v)) {
    const [r, g, b] = [v[1], v[2], v[3]];
    return `#${r}${r}${g}${g}${b}${b}` as `#${string}`;
  }
  return null;
}

/** Читает вычисленное значение семантического токена темы */
export function readThemeToken(name: string): string {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
}
